import common from './common'
import { REPORT_PARAMS } from '@/config/dataMap'
import { loadLoginStatus } from '@/utils/cache'
const vip_version = REPORT_PARAMS.vip_version

const redeemcodeKfmt = 'duba_jgpdf_redeemcode:7869 ver:byte step:byte result:int logon:byte'

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {
    /** 兑换码上报 */
    reportRedeemCodeKfmt (params) {
      const info = {
        ver: vip_version,
        step: 0, // 1 =会员中心点击【兑换会员】，2=兑换页面展示；3=点击兑换页面【兑换】；4=点击兑换页面【关闭】；
        result: 0, // 激活结果：1.激活成功；2.输入错误；3.已使用；4.已过期；
        logon: loadLoginStatus() ? 2 : 1// 账号登录状态：1=未登录，2=已登录
      }
      return common.REPORT.client_report_by_kfmt(redeemcodeKfmt, common.API.replaceObj(info, params))
    },

  }
}
